import axios from 'axios';
import { EnvironmentType } from '@/types/environmentType';

export default function useConfig({ type, configUrl }: Omit<EnvironmentType, 'defaultUrl' | 'specUrl'>) {
  return async function getConfig() {
    const { data } = await axios.get(configUrl);

    return data[type];
  };
}
